import { AboutMeData, Game, GameEngine, LinkImageSource, MediaType, Platform } from "./types";

export const PersonalInfo: AboutMeData = {
  name: "Josh Temple",
  role: "Generalist Game Programmer and Technical Designer",
  introduction: "Generalist Game Programmer and Technical Designer from the Bay Area, CA",
  description: "I'm Josh Temple, a game designer and programmer from the Bay Area, California. My love of games started when I fell in love with Magic: the Gathering after learning about it from the cool older kids at summer camp. Since then I've only fallen more in love with games in all their forms from card games to board games to video games. In the fall of 2023 I graduated from the University of California Santa Cruz with a B.S in Computer Science: Computer Game Design. If I'm not playing or working on a game you can probably find me watching a San Francisco Giants game or with my nose stuck in a Sci-Fi or Fantasy book. I'm currently looking for opportunities, so feel free to get in touch.",
  image: `${process.env.PUBLIC_URL}/images/Profile.jpg`,
  cvUri: `${process.env.PUBLIC_URL}/files/Josh_Temple_CV.pdf`,
  links: {
    github: "https://github.com/jktemple",
    itchIO: "https://jktemple.itch.io",
    linkedIn: "https://www.linkedin.com/in/josh-temple-50bb181a9",
  }
};

export const games: Game[] = [
  {
    name: "TurnStyle",
    teamsize: "11",
    projectLength: "4 Months",
    roles: ["Programmer"],
    description: "TurnStyle is a turn-based RPG with a (literal) twist! Rotate your party of 5 and learn to balance the stats of all your members in order to defeat the monsters of the subway.",
    genres: ["JRPG", "Narrative"],
    platforms: [Platform.Windows],
    engine: [GameEngine.Unity],
    links: [
      { source: LinkImageSource.ItchIo, url: "https://lion-slime.itch.io/turnstyle" },
    ],
    media: [
      { source: "/images/games/TurnStyle/TurnStyleScreenShot1.png", type: MediaType.Image },
      { source: "https://www.youtube.com/embed/vsJ6eBUVqvs?si=ndGIClOWg99qNpTu", type: MediaType.YouTube },
      { source: "/images/games/TurnStyle/TurnStyleScreenShot2.png", type: MediaType.Image },
      { source: "/images/games/TurnStyle/TurnStyleScreenShot3.png", type: MediaType.Image },
      { source: "/images/games/TurnStyle/TurnStyleScreenShot4.png", type: MediaType.Image },
    ],
    contributions : ["Ported original prototype from Phaser to Unity", "Implemented Combat Mechanics and Subway Map"]
  },
  {
    name: "Remembering Diane",
    teamsize: "6",
    projectLength: "2 Weeks ",
    roles: ["Lead Programmer"],
    description: "Remembering Diane is a short and sweet narrative experience about  remembering a life of fulfilling travels. You play as half of an elderly couple suffering from Alzheimer's trying to remember where they've been using the pictures and souvenirs that they have collected over time. The game created during TheXPlace's Summer Game Jam and was featured on Unity's Twitch.tv channel.",
    genres: ["Narrative"],
    platforms: [Platform.Windows],
    engine: [GameEngine.Unity],
    links: [
      { source: LinkImageSource.Github, url: "https://github.com/jktemple/TravelGame" },
      { source: LinkImageSource.ItchIo, url: "https://jktemple.itch.io/remembering-diane" },
    ],
    media: [
      { source: "/images/games/RememberingDiane/RememberingDianeScreenShot1.png", type: MediaType.Image},
      { source: "https://www.youtube.com/embed/nxfbAfXVAEc?si=Vkoo74xNqLOjg2Bh", type: MediaType.YouTube },
      { source: "/images/games/RememberingDiane/RememberingDianeScreenShot2.png", type: MediaType.Image},
    ],
    contributions : ["Implemented Ink dialouge system and UI"]
  },
  {
    name: "Untitled Parkour Game",
    teamsize: "12",
    projectLength: "6 Months",
    roles: ["Project Lead","Lead Programmer", "Lead Producer"],
    description: "Untitled Parkour Game is a Multiplayer 1st Person Parkour game made in Unity that was developed as part of my Senior Capstone sequence. It's heavily inspired by games like Mirror's Edge, Gorilla Tag, and many others.",
    genres: ["Action", "Platformer", "Multiplayer"],
    platforms: [Platform.Windows],
    engine: [GameEngine.Unity],
    links: [
      { source: LinkImageSource.Github, url: "https://github.com/jktemple/Untitled-Parkour-Game" },
      { source: LinkImageSource.ItchIo, url: "https://jktemple.itch.io/untitled-parkour-game" },
    ],
    media: [
      { source: "https://www.youtube.com/embed/oJ0AgYTD5xU?si=BtGP0_YcIQYcV3Dc", type: MediaType.YouTube },
    ],
    contributions : ["Designed and implemented core movement mechanics", "Handled Network programming using Netcode For GameObjects, Relay, and Lobby."]
  }
];

export const wips: Game[] = [
  {
    name: "Codename Steel Lizard",
    teamsize: "11",
    projectLength: "4 Months",
    roles: ["Programmer", "Designer"],
    description: "Codename Steel Lizard is a continuation of and/or a successor to Untitled Parkour Game. Starting from a brand new codebase with new movement mechanics like rope, bar swinging, and others, Codename Steel Lizard will be a single player experience focusing on exploration and puzzle solving. I'm currently working solo on the project and am currently prototyping and refining the movement mechanics, level design and puzzles. Once a vertical slice of the movement and puzzles is completed, I may begin to look for collaborators to build out the games visuals. If you're interested in potentially joining the project feel free to reach out.",
    genres: ["Action", "Adventure", "Platformer", "Puzzle"],
    platforms: [Platform.Windows],
    engine: [GameEngine.Unity],
    links: [
      { source: LinkImageSource.ItchIo, url: "https://lion-slime.itch.io/turnstyle" },
    ],
    media: [
      { source: "https://www.youtube.com/embed/I8KyiaUWrtU?si=rMVHpBtsMM2suoMD", type: MediaType.YouTube },
    ],
    contributions : ["Ported original prototype from Phaser to Unity", "Implemented Combat Mechanics and Subway Map"]
  },
];

export const otherWorks: Game[] = [
  {
    name: "3D Texturing",
    teamsize: "1",
    projectLength: "2 Weeks",
    roles: ["3D texture Artist"],
    description: "During my time since graduating from UC Santa Cruz I’ve sought out ways to expand my skillset outside of my core competency of programming and game design. One of those ways was taking a class in the basics of 3D texturing from my local community college. The class was taught in Substance Painter and the project displayed here was part of the coursework. I’m very inspired by the art of impressionist painters like Claude Monet and Renoir, so I made use of newly released Substance Painter features to try to emulate a similar style.",
    genres: ["JRPG", "Narrative"],
    platforms: [Platform.Windows],
    engine: [GameEngine.SubstancePainter, GameEngine.Blender],
    links: [
      { source: LinkImageSource.ItchIo, url: "https://lion-slime.itch.io/turnstyle" },
    ],
    media: [
      { source: "https://www.youtube.com/embed/_UTPG_cKgb8?si=SohdBK4umE8rzdCg", type: MediaType.YouTube },
      { source: "https://www.youtube.com/embed/_UTPG_cKgb8?si=0zVMv8AqdQqzvWog", type: MediaType.YouTube },
      { source: "/images/other/3DTexturing/SubstancePainterScreenshot1.png", type: MediaType.Image },
    ],
    contributions : ["Ported original prototype from Phaser to Unity", "Implemented Combat Mechanics and Subway Map"]
  },
  {
    name: "Unreal Stylized Rendering",
    teamsize: "1",
    projectLength: "2 Weeks",
    roles: ["3D texture Artist"],
    description: "For this project I decided to branch out from my usual Unity comfort zone and get a little more familiar with Unreal Engine. I created two different full screen post-processing effects. The first effect is a physically based cell-shading and outline shader, while the second is a painterly effect using an anisotropic Kuwahara filter. Each shader makes use of custom shader code nodes in Unreal’s material graph to achieve the desired results and can be seen tested on the same sample scene I found in the Unreal Marketplace. ",
    genres: ["JRPG", "Narrative"],
    platforms: [Platform.Windows],
    engine: [GameEngine.Unreal],
    links: [
      { source: LinkImageSource.ItchIo, url: "https://lion-slime.itch.io/turnstyle" },
    ],
    media: [
      { source: "https://www.youtube.com/embed/od_PaU07GqM?si=2X0bYXtMK_EvrkPH", type: MediaType.YouTube },
      { source: "https://www.youtube.com/embed/6O1dUHdllFw?si=ZrNy1lJvUCMPOd0m", type: MediaType.YouTube },
      { source: "/images/other/Shaders/KuwaharaScreenShot1.png", type: MediaType.Image },
      { source: "/images/other/Shaders/CellShadingScreenShot1.png", type: MediaType.Image },
      { source: "/images/other/Shaders/CellShadingScreenShot2.png", type: MediaType.Image },
      { source: "/images/other/Shaders/CellShadingScreenShot3.png", type: MediaType.Image },
      
    ],
    contributions : ["Ported original prototype from Phaser to Unity", "Implemented Combat Mechanics and Subway Map"]
  },
  {
    name: "Low Poly Wave Shader",
    teamsize: "1",
    projectLength: "2 Weeks",
    roles: ["3D texture Artist"],
    description: "This small project was used to dip my toes into the world of shader programming in Unity. I set out to create a low-poly stylized wave shader. The shader is made using Unity’s Shader Graph and combines both displacement and fragment shading. The shader also includes depth and foam effects, both at the edges of objects and at the crest of waves.",
    genres: ["JRPG", "Narrative"],
    platforms: [Platform.Windows],
    engine: [GameEngine.Unity],
    links: [
      { source: LinkImageSource.ItchIo, url: "https://lion-slime.itch.io/turnstyle" },
    ],
    media: [
      { source: "https://www.youtube.com/embed/RIwOhX0Lt3U?si=MEXLWllE2Eagkw3N", type: MediaType.YouTube },
      { source: "https://www.youtube.com/embed/eVaIo52wt2w?si=1GHtWG_eP5CPFYwF", type: MediaType.YouTube },
      { source: "/images/other/Shaders/WaveShaderScreenShot1.png", type: MediaType.Image },
      { source: "/images/other/Shaders/WaveShaderScreenShot2.png", type: MediaType.Image },
    ],
    contributions : ["Ported original prototype from Phaser to Unity", "Implemented Combat Mechanics and Subway Map"]
  },
];
